import React, { useState, useEffect } from 'react';

const DisclaimerModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenDisclaimer = localStorage.getItem('hasSeenDisclaimer');
    if (!hasSeenDisclaimer) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('hasSeenDisclaimer', 'true');
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 animate-fade-in">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Disclaimer</h2>
        <div className="text-gray-700 mb-6 text-sm leading-relaxed">
          <p>
            Any investment options or services discussed on this website involve significant risk as in any investment. 
            This information is neither an offer to sell, nor a solicitation of an offer to buy any of these services 
            or products. For more complete information, please read the offering carefully before you invest or take 
            any advice from us.
          </p>
        </div>
        <button
          onClick={handleClose}
          className="w-full bg-gray-800 text-white py-3 rounded-lg hover:bg-gray-900 transition-colors font-semibold"
        >
          I Understand
        </button>
      </div>
    </div>
  );
};

export default DisclaimerModal;
